export default __webpack_public_path__ + "static/media/(47).355bd587.jpg";